import jwtDecode from 'jwt-decode';
import VT from '@/store/types';

export default {
  [VT.SET_AUTH_INFO]: (state, data) => {
    state.roles = data.user.roles;
    state.user = data.user.user;
    state.tv_code = data.tv_code;
    state.projects_info = data.projects_info;
    state.project_leads = data.project_leads;
    state.jira_user = data.jira_user;

    const permissions = [];
    for (let i = 0; i < data.user.permissions.length; i++) {
      permissions.push(data.user.permissions[i].name);
    }
    data.user.roles.forEach((role) => role.permissions.forEach((permission) => {
      if (permission.name) permissions.push(permission.name);
    }));

    // for (let i = 0; i < data.user.roles.length; i++) {
    //   for (let j = 0; j < data.user.roles[i].permissions.length; j++) {
    //     if (!permissions.includes(data.user.roles[i].permissions[j].name)) {
    //       permissions.push(data.user.roles[i].permissions[j].name);
    //     }
    //   }
    // }
    state.permissions = permissions;
    // state.projects = data.projects;

    // if (!state.activeProjectId && state.user.project_users.length > 0) state.activeProjectId = state.user.project_users[0].project_id;
    // if (!state.activeProjectId
    //   && state.projects.length > 0) state.activeProjectId = state.projects[0].id;
    // if (state.user.project_users.length === 0
    //   && state.projects.length === 0) state.activeProjectId = null;
  },
  [VT.SET_AUTH_TOKEN]: (state, token) => {
    state.token = token;
    state.exp = typeof state.token === 'string' && state.token.length > 0 ? jwtDecode(state.token).exp : 0;
    if (!token) {
      state.tv_code = null;
    }
  },
  [VT.SET_REFRESH_TOKEN]: (state, token) => {
    state.refreshToken = token;
    state.refreshTokenExp = typeof state.refreshToken === 'string'
    && state.refreshToken.length > 0 ? jwtDecode(state.refreshToken).exp : 0;
  },

  // [VT.SET_ACTIVE_PROJECT]: (state, projectId) => {
  //   state.activeProjectId = projectId;
  // },

};
